import Constants from '@/Constants';
import { Group } from '@/models/Group';
import { ApplicationState } from '@/store';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ConfirmDialog, { PropsType as ConfirmDialogPropsType } from '../../../../components/ConfirmDialog';
import './style.scss';

interface GroupCardProps {
    data: Group[];
    showClassScreen?: boolean;
    remove: (id: number) => void;
}

export const GroupCard = ({ data, remove, showClassScreen = false }: GroupCardProps) => {
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));
    const [modalConfig, setModalConfig] = useState<ConfirmDialogPropsType>({} as ConfirmDialogPropsType);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [confirm, setConfirm] = useState<boolean>(false);
    const [idGroupRemove, setIdGroupRemove] = useState<number>(0);
    const history = useHistory();

    const onWarningModal = (id: number) => {
        setShowModal(true);

        setModalConfig({
            leftButtonTitle: strings.YES,
            leftClick: () => setConfirm(true),
            rightButtonTitle: strings.NO,
            rightClick: () => setShowModal(false),
            content: strings.WILL_REMOVE_THE_TARGET_AUDIENCE,
            subContent: strings.WHEN_DELETING_ENROLLED_USERS_THEY_WILL_NOT_BE_UNENROLLED,
        } as ConfirmDialogPropsType);

        setIdGroupRemove(id);
    };

    if (confirm && showModal) {
        if (idGroupRemove !== 0) {
            remove && remove(idGroupRemove);
            setShowModal(false);
            setConfirm(false);
        }
    }

    const onNavigateEditGroup = (id: number) => {
        history.push(`/group/${id}/edit`);
    };

    return (
        <>
            {showModal && (
                <ConfirmDialog
                    content={modalConfig.content}
                    leftButtonTitle={modalConfig.leftButtonTitle}
                    leftClick={() => modalConfig.leftClick && modalConfig.leftClick()}
                    rightButtonTitle={modalConfig.rightButtonTitle}
                    rightClick={() => modalConfig.rightClick && modalConfig.rightClick()}
                    show={showModal}
                    subContent={modalConfig.subContent}
                />
            )}
            {data &&
                data.length > 0 &&
                data.map((group: Group) => {
                    if (group.name !== 'All Users')
                        return (
                            <div className="group-card__container" key={group.id}>
                                <span className="group-card__container__title">{group.name}</span>
                                <span className="group-card__container__icon">
                                    <div className="dropdown">
                                        <i aria-expanded="false" className="material-icons" data-toggle="dropdown">
                                            {Constants.icons.MORE_HORIZ}
                                        </i>
                                        <div className="dropdown-menu">
                                            {!showClassScreen && (
                                                <button className="dropdown-item" onClick={() => onNavigateEditGroup(group.id)} type="button">
                                                    {strings.EDIT}
                                                </button>
                                            )}
                                            <button
                                                className="dropdown-item"
                                                onClick={() => {
                                                    showClassScreen ? remove(group.id) : onWarningModal(group.id);
                                                }}
                                                type="button"
                                            >
                                                {strings.REMOVE}
                                            </button>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        );
                })}
        </>
    );
};
